import script from "./BaseRadioGroup.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseRadioGroup.vue?vue&type=script&setup=true&lang=ts"

import "./BaseRadioGroup.vue?vue&type=style&index=0&id=63bc1a6c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63bc1a6c"]])

export default __exports__